export const DIFF_TYPE = {
    NO_DIFF: 'NO_DIFF',
    MAJOR: 'MAJOR',
    MINOR: 'MINOR',
} as const;

export type DiffType = (typeof DIFF_TYPE)[keyof typeof DIFF_TYPE];

export const DIFF_TYPES_PRIORITY = {
    [DIFF_TYPE.MAJOR]: 0,
    [DIFF_TYPE.MINOR]: 1,
    [DIFF_TYPE.NO_DIFF]: Infinity,
};

export const RECONCILIATION_OPERATION = {
    ACCEPT: 'ACCEPT',
    REJECT: 'REJECT',
} as const;
